export const possibleIntolerances = [
  { id: 2, name: "Alcohol-Free" },
  { id: 3, name: "Celery-Free" },
  { id: 4, name: "Crustacean-Free" },
  { id: 5, name: "Dairy-Free" },
  { id: 6, name: "DASH" },
  { id: 7, name: "Egg-Free" },
  { id: 8, name: "Fish-Free" },
  { id: 9, name: "Fodmap-Free" },
  { id: 10, name: "Gluten-Free" },
  { id: 11, name: "Immuno-Supportive" },
  { id: 12, name: "Keto-Friendly" },
  { id: 13, name: "Kidney-Friendly" },
  { id: 14, name: "Kosher" },
  { id: 15, name: "Low Potassium" },
  { id: 16, name: "Low Sugar" },
  { id: 17, name: "Lupine-Free" },
  { id: 18, name: "Mediterranean" },
  { id: 19, name: "Mollusk-Free" },
  { id: 20, name: "Mustard-Free" },
  { id: 21, name: "No oil added" },
  { id: 22, name: "Paleo" },
  { id: 23, name: "Peanut-Free" },
  { id: 24, name: "Pescatarian" },
  { id: 25, name: "Pork-Free" },
  { id: 26, name: "Red-Meat-Free" },
  { id: 27, name: "Sesame-Free" },
  { id: 28, name: "Shellfish-Free" },
  { id: 29, name: "Soy-Free" },
  { id: 30, name: "Sugar-Conscious" },
  { id: 31, name: "Sulfite-Free" },
  { id: 32, name: "Tree-Nut-Free" },
  { id: 33, name: "Vegan" },
  { id: 34, name: "Vegetarian" },
  { id: 35, name: "Wheat-Free" },
];

export const filterData = [
  {
    name: "mealTypes",
    labels: [
      { label: "breakfast", value: "Breakfast" },
      { label: "brunch", value: "Brunch" },
      { label: "snack", value: "Snack" },
      { label: "lunch", value: "Lunch" },
      { label: "dinner", value: "Dinner" },
    ],
  },
  {
    name: "dishTypes",
    labels: [
      { label: "starter", value: "Starter" },
      { label: "main course", value: "Main course" },
      { label: "side dish", value: "Side dish" },
      { label: "soup", value: "Soup" },
      { label: "desserts", value: "Desserts" },
      { label: "biscuits", value: "Biscuits and cookies" },
      { label: "sauces", value: "Condiments and sauces" },
      { label: "drinks", value: "Drinks" },
      { label: "cereals", value: "Cereals" },
      { label: "sandwiches", value: "Sandwiches" },
      { label: "salad", value: "Salad" },
    ],
  },

  {
    name: "cuisineTypes",
    labels: [
      { label: "American", value: "American" },
      { label: "Asian", value: "Asian" },
      { label: "British", value: "British" },
      { label: "Caribbean", value: "Caribbean" },
      { label: "Central Europe", value: "Central Europe" },
      { label: "Chinese", value: "Chinese" },
      { label: "Eastern Europe", value: "Eastern Europe" },
      { label: "French", value: "French" },
      { label: "Indian", value: "Indian" },
      { label: "Italian", value: "Italian" },
      { label: "Japanese", value: "Japanese" },
      { label: "Mediterranean", value: "Mediterranean" },
      { label: "Mexican", value: "Mexican" },
      { label: "Middle Eastern", value: "Middle Eastern" },
      { label: "Nordic", value: "Nordic" },
      { label: "South American", value: "South American" },
      { label: "South East Asian", value: "South East Asian" },
    ],
  },
];
